<template>
    <div id="ActivityLogList" class="internal-table-border">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <template v-if="activityLogVal != undefined">
            <div class="activity-log-section" v-if="activityLogVal == 'woloadList'">
                <template v-if="rows.length > 0">
                <template v-for="(row,ind) in rows">
                    <div :key="ind" class="activity-log-list mt-2">
                        <span v-if="row.name=='Work order create'" class="color-8fc7c2 line-circle"></span>
                        <span v-else-if="row.name=='Work order update'" class="color-8fc794 line-circle"></span>
                        <span v-else-if="row.name=='Work order line item create'" class="color-8fc7c2 line-circle"></span>
                        <span v-else-if="row.name=='Work order line item update'" class="color-c2c5a5 line-circle"></span>
                        <span v-else-if="row.name=='Delete work order item'" class="color-c5a5c1 line-circle"></span>
                        <span v-else-if="row.name=='Work order comment create'" class="color-8fc7c2 line-circle"></span>
                        <span v-else-if="row.name=='Work order component create'" class="color-8fc7c2 line-circle"></span>
                        <span v-else-if="row.name=='Work order labor create'" class="color-8fc7c2 line-circle"></span>
                        <span v-else-if="row.name=='Delete work order component'" class="color-c5a5c1 line-circle"></span>
                        <span v-else-if="row.name=='Delete work order labor'" class="color-c5a5c1 line-circle"></span>
                        <span v-else  class="color-c5a5c1 line-circle"></span>
                        <h5>{{row.name}} </h5>
                        <p> {{row.description}} </p>
                        <div class="workorder-btm-list">
                            <p> <i class="fp-user"></i> <span class="log-value"> {{row.performed_by}} </span> </p>
                            <p> <i class="fp-calendar"></i> <span class="log-value"> {{row.performed_at}} </span> </p>
                            <!-- <p> <i class="fp-down-arrow color-blue"></i> <span class="log-value"> Change work order item <span class="updated-value">"Lorem ipsm Dolar" </span> to <span class="updated-value">"consectetur adipiscing elit"</span> </span> </p>  -->
                            <div class="updated-logdetail" v-if="row.details.length">
                                <div class="activitylog">
                                    <h5 class="color-blue">
                                        <i class="fp-down-arrow cursor-pointer" data-toggle="collapse" :data-target="'#activityDetail'+ind"></i>
                                        View Details
                                    </h5>
                                </div>
                                <div :id="'activityDetail'+ind" class="collapse">
                                    <ul>
                                        <template v-for="(detail,dind) in row.details">
                                            <li :key="dind" v-if="detail.key=='add'"><span class='updated-value'>{{ detail.val1 }}</span> {{ detail.val2 }}  <span class='updated-value'>{{ detail.val3 }}</span></li>
                                            <li :key="dind" v-if="detail.key=='is_added'"><span class='updated-value'>{{ detail.val1 }} </span><span class='updated-value'>{{ detail.val2 }}</span> {{ detail.val3 }}</li>
                                            <li :key="dind" v-if="detail.key=='update'"><span class='updated-value'>{{ detail.val1 }}</span> {{ detail.val2 }} <span class='updated-value'>{{ detail.val3 }}</span> {{ detail.val4 }} <span class='updated-value'>{{ detail.val5 }}</span></li>
                                            <li :key="dind" v-if="detail.key=='removed'"><span class='updated-value'>{{ detail.val1 }}</span><span class='updated-value'> {{ detail.val2 }}</span> {{ detail.val3 }}</li>
                                            <li :key="dind" v-if="detail.key=='delete'"><span class='updated-value'> {{ detail.val1 }}</span> {{ detail.val2 }} <span class='updated-value'>{{ detail.val3 }}</span></li>
                                        </template>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a class="btn btn-secondary pull-right mt-2 mr-2" v-if="ind == rows.length - 1 && ind < totalRecords - 1" href="javascript:void(0)" v-on:click="loadMoreData()"> Load More</a>
                </template>
                </template>
                <template v-else>
                <div class="no-activity-found">
                    <h5>No Activity Found.</h5>
                </div>
                </template>
            </div>
            <!-- Vendor Purchase Order Activity Log -->
            <div class="activity-log-section" v-if="activityLogVal == 'vendorpoloadList'">
                <template v-if="rows.length > 0">
                <template v-for="(row,ind) in rows">
                    <div :key="ind" class="activity-log-list">
                        <span v-if="row.name=='Vendor purchase order create'" class="color-8fc7c2 line-circle"></span>
                        <span v-else-if="row.name=='Vendor purchase order update'" class="color-8fc794 line-circle"></span>
                        <span v-else-if="row.name=='Vendor purchase order item added'" class="color-8fc7c2 line-circle"></span>
                        <span v-else-if="row.name=='Vendor purchase order item update'" class="color-c2c5a5 line-circle"></span>
                        <span v-else-if="row.name=='Delete vendor purchase order'" class="color-c5a5c1 line-circle"></span>
                        <span v-else  class="color-c5a5c1 line-circle"></span>
                        <h5>{{row.name}} </h5>
                        <p> {{row.description}} </p>
                        <div class="workorder-btm-list">
                            <p> <i class="fp-user"></i> <span class="log-value"> {{row.performed_by}} </span> </p>
                            <p> <i class="fp-calendar"></i> <span class="log-value"> {{row.performed_at}} </span> </p>

                            <div class="updated-logdetail" v-if="row.details.length">
                                <div class="vendor-purchase-activity">
                                    <h5 class="color-blue">
                                        <i class="fp-down-arrow cursor-pointer" data-toggle="collapse" :data-target="'#activityDetail'+ind"></i>
                                        View Details
                                    </h5>
                                </div>
                                <div :id="'activityDetail'+ind" class="collapse">
                                    <ul>
                                        <template v-for="(detail,dind) in row.details">
                                            <li :key="dind" v-if="detail.key=='add'"><span class='updated-value'>{{ detail.val1 }}</span> {{ detail.val2 }}  <span class='updated-value'>{{ detail.val3 }}</span></li>
                                            <li :key="dind" v-if="detail.key=='is_added'"><span class='updated-value'>{{ detail.val1 }} </span><span class='updated-value'>{{ detail.val2 }}</span> {{ detail.val3 }}</li>
                                            <li :key="dind" v-if="detail.key=='update'"><span class='updated-value'>{{ detail.val1 }}</span> {{ detail.val2 }} <span class='updated-value'>{{ detail.val3 }}</span> {{ detail.val4 }} <span class='updated-value'>{{ detail.val5 }}</span></li>
                                            <li :key="dind" v-if="detail.key=='removed'"><span class='updated-value'>{{ detail.val1 }}</span><span class='updated-value'> {{ detail.val2 }}</span> {{ detail.val3 }}</li>
                                            <li :key="dind" v-if="detail.key=='delete'"><span class='updated-value'> {{ detail.val1 }}</span> {{ detail.val2 }} <span class='updated-value'>{{ detail.val3 }}</span></li>
                                        </template>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a :key="ind" class="btn btn-secondary pull-right" v-if="ind == rows.length - 1 && ind < totalRecords - 1" href="javascript:void(0)" v-on:click="loadMoreData()"> Load More</a>
                </template>
                </template>
                <template v-else>
                <div class="no-activity-found">
                    <h5>No Activity Found.</h5>
                </div>
                </template>
            </div>

            <!-- Invoice Activity Log -->
            <div class="activity-log-section" v-if="activityLogVal == 'invoiceloadList'">
                <template v-if="rows.length > 0">
                <template v-for="(row,item_index) in rows">
                    <div :key="item_index" class="activity-log-list">
                        <span v-if="row.name=='Invoice update'" class="color-8fc794 line-circle"></span>
                        <span v-else-if="row.name=='Invoice item create'" class="color-8fc7c2 line-circle"></span>
                        <span v-else-if="row.name=='Invoice item update'" class="color-c2c5a5 line-circle"></span>
                        <span v-else-if="row.name=='Delete invoice item'" class="color-c5a5c1 line-circle"></span>
                        <span v-else  class="color-c5a5c1 line-circle"></span>
                        <h5>{{row.name}} </h5>
                        <p> {{row.description}} </p>
                        <div class="workorder-btm-list">
                            <p> <i class="fp-user"></i> <span class="log-value"> {{row.performed_by}} </span> </p>
                            <p> <i class="fp-calendar"></i> <span class="log-value"> {{row.performed_at}} </span> </p>
                            <!-- <p> <i class="fp-down-arrow color-blue"></i> <span class="log-value"> Change work order item <span class="updated-value">"Lorem ipsm Dolar" </span> to <span class="updated-value">"consectetur adipiscing elit"</span> </span> </p>  -->
                            <div class="updated-logdetail" v-if="row.details && row.details.length">
                                <div class="invoice-activity">
                                    <h5 class="color-blue">
                                        <i class="fp-down-arrow cursor-pointer" data-toggle="collapse" :data-target="'#activityDetail'+item_index"></i>
                                        View Details
                                    </h5>
                                </div>
                                <div :id="'activityDetail'+item_index" class="collapse">
                                    <ul>
                                        <template v-for="(detail,dind) in row.details">
                                            <li :key="dind" v-if="detail.key=='add'"><span class='updated-value'>{{ detail.val1 }}</span> {{ detail.val2 }}  <span class='updated-value'>{{ detail.val3 }}</span></li>
                                            <li :key="dind" v-if="detail.key=='is_added'"><span class='updated-value'>{{ detail.val1 }} </span><span class='updated-value'>{{ detail.val2 }}</span> {{ detail.val3 }}</li>
                                            <li :key="dind" v-if="detail.key=='update'"><span class='updated-value'>{{ detail.val1 }}</span> {{ detail.val2 }} <span class='updated-value'>{{ detail.val3 }}</span> {{ detail.val4 }} <span class='updated-value'>{{ detail.val5 }}</span></li>
                                            <li :key="dind" v-if="detail.key=='removed'"><span class='updated-value'>{{ detail.val1 }}</span><span class='updated-value'> {{ detail.val2 }}</span> {{ detail.val3 }}</li>
                                            <li :key="dind" v-if="detail.key=='delete'"><span class='updated-value'> {{ detail.val1 }}</span> {{ detail.val2 }} <span class='updated-value'>{{ detail.val3 }}</span></li>
                                        </template>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a :key="item_index" class="btn btn-secondary pull-right" v-if="item_index == rows.length - 1 && item_index < totalRecords - 1" href="javascript:void(0)" v-on:click="loadMoreData()"> Load More</a>
                </template>
                </template>
                <template v-else>
                <div class="no-activity-found">
                    <h5>No Activity Found.</h5>
                </div>
                </template>
            </div>
            <!-- Bill Activity Log -->
            <div class="activity-log-section" v-if="activityLogVal == 'billloadList'">
                <template v-if="rows.length > 0">
                <template v-for="(row,item_index) in rows">
                    <div :key="item_index" class="activity-log-list">
                        <span v-if="row.name=='Vendor invoice update'" class="color-8fc794 line-circle"></span>
                        <span v-else-if="row.name=='Vendor invoice item create'" class="color-8fc7c2 line-circle"></span>
                        <span v-else-if="row.name=='Vendor invoice item update'" class="color-c2c5a5 line-circle"></span>
                        <span v-else-if="row.name=='Delete vendor invoice item'" class="color-c5a5c1 line-circle"></span>
                        <span v-else  class="color-c5a5c1 line-circle"></span>
                        <h5>{{row.name}} </h5>
                        <p> {{row.description}} </p>
                        <div class="workorder-btm-list">
                            <p> <i class="fp-user"></i> <span class="log-value"> {{row.performed_by}} </span> </p>
                            <p> <i class="fp-calendar"></i> <span class="log-value"> {{row.performed_at}} </span> </p>
                            <!-- <p> <i class="fp-down-arrow color-blue"></i> <span class="log-value"> Change work order item <span class="updated-value">"Lorem ipsm Dolar" </span> to <span class="updated-value">"consectetur adipiscing elit"</span> </span> </p>  -->
                            <div class="updated-logdetail" v-if="row.details.length">
                                <div class="bill-activity">
                                    <h5 class="color-blue">
                                        <i class="fp-down-arrow cursor-pointer" data-toggle="collapse" :data-target="'#activityDetail'+item_index"></i>
                                        View Details
                                    </h5>
                                </div>
                                <div :id="'activityDetail'+item_index" class="collapse">
                                    <ul>
                                        <template v-for="(detail,dind) in row.details">
                                            <li :key="dind" v-if="detail.key=='add'"><span class='updated-value'>{{ detail.val1 }}</span> {{ detail.val2 }}  <span class='updated-value'>{{ detail.val3 }}</span></li>
                                            <li :key="dind" v-if="detail.key=='is_added'"><span class='updated-value'>{{ detail.val1 }} </span><span class='updated-value'>{{ detail.val2 }}</span> {{ detail.val3 }}</li>
                                            <li :key="dind" v-if="detail.key=='update'"><span class='updated-value'>{{ detail.val1 }}</span> {{ detail.val2 }} <span class='updated-value'>{{ detail.val3 }}</span> {{ detail.val4 }} <span class='updated-value'>{{ detail.val5 }}</span></li>
                                            <li :key="dind" v-if="detail.key=='removed'"><span class='updated-value'>{{ detail.val1 }}</span><span class='updated-value'> {{ detail.val2 }}</span> {{ detail.val3 }}</li>
                                            <li :key="dind" v-if="detail.key=='delete'"><span class='updated-value'> {{ detail.val1 }}</span> {{ detail.val2 }} <span class='updated-value'>{{ detail.val3 }}</span></li>
                                        </template>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a :key="item_index" class="btn btn-secondary pull-right" v-if="item_index == rows.length - 1 && item_index < totalRecords - 1" href="javascript:void(0)" v-on:click="loadMoreData()"> Load More</a>
                </template>
                </template>
                <template v-else>
                <div class="no-activity-found">
                    <h5>No Activity Found.</h5>
                </div>
                </template>
            </div>

            <!-- Payment Activity Log -->
            <div class="activity-log-section" v-if="activityLogVal == 'vendorPaymentloadList'">
                <template v-if="rows.length > 0">
                    <template v-for="(row,item_index) in rows">
                        <div :key="item_index" class="activity-log-list">
                            <span v-if="row.name=='Vendor payment create'" class="color-8fc794 line-circle"></span>
                            <span v-else-if="row.name=='Vendor payment status update'" class="color-c2c5a5 line-circle"></span>
                            <span v-else-if="row.name=='Vendor payment tag update'" class="color-8fc7c2 line-circle"></span>
                            <span v-else-if="row.name=='Vendor payment date update'" class="color-c5a5c1 line-circle"></span>
                            <span v-else-if="row.name=='Vendor payment tag delete'" class="color-8fc794 line-circle"></span>
                            <h5>{{row.name}} </h5>
                            <p> {{row.description}} </p>
                            <div class="workorder-btm-list">
                                <p> <i class="fp-user"></i> <span class="log-value"> {{row.performed_by}} </span> </p>
                                <p> <i class="fp-calendar"></i> <span class="log-value"> {{row.performed_at}} </span> </p>
                                <!-- <p> <i class="fp-down-arrow color-blue"></i> <span class="log-value"> Change work order item <span class="updated-value">"Lorem ipsm Dolar" </span> to <span class="updated-value">"consectetur adipiscing elit"</span> </span> </p>  -->
                                <div class="updated-logdetail" v-if="row.details.length">
                                    <div class="payment-activity">
                                        <h5 class="color-blue">
                                            <i class="fp-down-arrow cursor-pointer" data-toggle="collapse" :data-target="'#activityDetail'+item_index"></i>
                                            View Details
                                        </h5>
                                    </div>
                                    <div :id="'activityDetail'+item_index" class="collapse">
                                        <ul>
                                            <template v-for="(detail,dind) in row.details">
                                                <li :key="dind" v-if="detail.key=='add'"><span class='updated-value'>{{ detail.val1 }}</span> {{ detail.val2 }}  <span class='updated-value'>{{ detail.val3 }}</span></li>
                                                <li :key="dind" v-if="detail.key=='is_added'"><span class='updated-value'>{{ detail.val1 }} </span><span class='updated-value'>{{ detail.val2 }}</span> {{ detail.val3 }}</li>
                                                <li :key="dind" v-if="detail.key=='update'"><span class='updated-value'>{{ detail.val1 }}</span> {{ detail.val2 }} <span class='updated-value'>{{ detail.val3 }}</span> {{ detail.val4 }} <span class='updated-value'>{{ detail.val5 }}</span></li>
                                                <li :key="dind" v-if="detail.key=='removed'"><span class='updated-value'>{{ detail.val1 }}</span><span class='updated-value'> {{ detail.val2 }}</span> {{ detail.val3 }}</li>
                                                <li :key="dind" v-if="detail.key=='delete'"><span class='updated-value'> {{ detail.val1 }}</span> {{ detail.val2 }} <span class='updated-value'>{{ detail.val3 }}</span></li>
                                        </template>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </template>
                <template v-else>
                <div class="no-activity-found">
                    <h5>No Activity Found.</h5>
                </div>
                </template>
            </div>
            <template v-if="activityLogVal == 'loadList'">
                <div class="view-page-table bg-white data-table p-0">
                    <vue-good-table
                        ref="listActivityLogTable"
                        mode="remote"
                        title="ActivityLog"
                        @on-page-change="onPageChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        :totalRows="totalRecords"
                        :columns="columns"
                        :rows="rows"
                        :pagination-options="{
                            enabled: true,
                            position: 'bottom',
                            perPage: perPage,
                            perPageDropdown:dropDownPerPage,
                            dropdownAllowAll: false,
                        }"
                        >
                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                            <div :key="key">
                                <div v-if="props.column.field == 'action'" class='text-center'>
                                    <a v-if="canViewLog && props.row.flag != 'no'" v-on:click.prevent="getActivityLogInfo(props.row.id)" class="fp-view" href="javascript:void(0)"></a>
                                </div>
                                <div v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </div>
                            </div>
                        </template>
                    </vue-good-table>
                </div>
            </template>

        </template>

        <div id="page-content-wrapper" class="admin-content-area" v-else>
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title">{{pageTitle}} </div>
                        <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content activity-log-lists">
                        <data-table-filter-config :moduleName="'ActivityLogList'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'ActivityLogList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                    ref="listActivityLogTable"
                                    mode="remote"
                                    title="ActivityLog"
                                    @on-page-change="onPageChange"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }"
                                    >
                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <a v-if="canViewLog && props.row.flag != 'no'" v-on:click.prevent="getActivityLogInfo(props.row.id)" class="fp-view" href="javascript:void(0)"></a>
                                                <a v-else href="javascript:void(0)">-</a>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

        <div class="modal fade customer-activity-modal" id="activityLogViewModal" ref="activityLogViewModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ activityLogViewHeader }}</h5>
                    </div>
                    <div class="modal-body table-responsive-sm">
                        <table  aria-describedby="table" class="table table-sm table-bordered font-1" style="table-layout: fixed; width: 100%">
                            <thead>
                                <tr class="table-primary">
                                    <th>Label</th>
                                    <th>Current Value</th>
                                    <th>Old Value</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(section, label) in fieldArr">
                                    <tr v-bind:key="label">
                                        <td style="word-wrap: break-word; white-space: normal">
                                            <template v-if="label == 'bill_number'">{{ ucStringKey('Invoice #')+ ' :' }}</template>
                                            <template v-else-if="label == 'bill_date'">{{ ucStringKey('Invoice Date')+ ' :' }}</template>
                                            <template v-else>{{ ucStringKey(label)+ ' :' }}</template>
                                        </td>
                                        <td style="word-wrap: break-word; white-space: normal">
                                            <template v-if="label=='doc_path' || label=='insurance_doc' || label=='resale_doc_path' || label=='img_path' || label=='file_path' || label == 'insurance_certificate_path'">
                                                <p style=" word-break: break-all;" v-fp-html="section.new_value"></p>
                                            </template>
                                            <template v-else-if="label=='signature' || label=='signature1'">
                                                <p v-if="section.new_value!='-'"> <img :src="section.new_value" height="200" width="200" alt=""></p>
                                                <p v-else>{{section.new_value}}</p>
                                            </template>
                                            <template v-else-if="label=='other_rates' || label=='final_rates'">
                                                <p v-if="section.new_value.length">
                                                <template v-for="(othrateArr , othratekey) in section.new_value">
                                                    <div class="row table-view-detail" :key="othratekey">
                                                        <div class="col-md-8" v-if="othrateArr.name === 'government_compliance'">
                                                        Govt. Compliance <br>($ {{numberFormat(othrateArr.rate) + " X " + othrateArr.unit + ' ' + othrateArr.type}})
                                                        </div>
                                                        <div class="col-md-8" v-else>
                                                        {{ucStringKey(othrateArr.name)}} <br>($ {{numberFormat(othrateArr.rate) + " X " + othrateArr.unit + ' ' + othrateArr.type}})
                                                        </div>
                                                        <div class="col-md-4">
                                                            : {{ numberFormat(othrateArr.total)}}
                                                        </div>
                                                    </div>
                                                </template>
                                                </p>
                                                <p v-else>-</p>
                                            </template>
                                            <template v-else-if="label=='insurance_rates'">
                                                <p v-if="section.new_value.length">
                                                    <template v-for="(insuranceArr , insurancekey) in section.new_value">
                                                        <div class="row table-view-detail" :key="insurancekey">
                                                            Insurance Name: {{ucStringKey(insuranceArr.Insurance_name)}}<br>
                                                            Days :{{insuranceArr.Days}}<br>
                                                            Type :{{insuranceArr.type}}<br>
                                                            Insurance Charge :{{numberFormat(insuranceArr.Insurance_charge)}}<br>
                                                            Total :{{insuranceArr.Total}}<br>
                                                        </div>
                                                    </template>
                                                </p>
                                                <p v-else>-</p>
                                            </template>
                                            <template v-else-if="label=='extra_features'">
                                                <p v-if="section.new_value.length">
                                                    <template v-for="(featureArr , featurekey) in section.new_value">
                                                        <div class="row table-view-detail" :key="featurekey">
                                                            {{ucStringKey(featureArr.text)}} : {{ucStringKey(featureArr.value)}}<br>
                                                        </div>
                                                    </template>
                                                </p>
                                                <p v-else>-</p>
                                            </template>
                                            <template v-else-if="label=='insurance_charges'">
                                                <p v-if="section.new_value.length">
                                                    <template v-for="(insChargeArr , inschargekey) in section.new_value">
                                                        <div class="row table-view-detail" v-if="insChargeArr.physical_ins_charges != undefined" :key="'phy'+inschargekey">
                                                            <div class="col-md-8" :key="'physical_ins_detail' + inschargekey">
                                                                {{ucStringKey(insChargeArr.phy_charges_name)}} <br>($ {{numberFormat(insChargeArr.physical_ins_charges) + " X " + insChargeArr.days + ' ' + insChargeArr.phy_charges_type}})
                                                            </div>
                                                            <div class="col-md-4" :key="'physical_ins' + inschargekey">
                                                                : {{ numberFormat(insChargeArr.physical_ins_total)}}
                                                            </div>
                                                        </div>
                                                        <div class="row table-view-detail" v-if="insChargeArr.physical_admin_charges != undefined" :key="'phy_admin'+inschargekey">
                                                            <div class="col-md-8" :key="'physical_admin_detail' + inschargekey">
                                                                {{ucStringKey(insChargeArr.phy_admincharges_name)}} <br>($ {{numberFormat(insChargeArr.physical_admin_charges) + " X " + insChargeArr.days + ' ' + insChargeArr.phy_admin_type}})
                                                            </div>
                                                            <div class="col-md-4" :key="'physical_admin' + inschargekey">
                                                                : {{ numberFormat(insChargeArr.physical_admin_total)}}
                                                            </div>
                                                        </div>
                                                        <div class="row table-view-detail" v-if="insChargeArr.liability_insurance_charges != undefined" :key="'lia'+inschargekey">
                                                            <div class="col-md-8" :key="'liability_ins_detail' + inschargekey">
                                                                {{ucStringKey(insChargeArr.lia_insurance_name)}} <br>($ {{numberFormat(insChargeArr.liability_insurance_charges) + " X " + insChargeArr.days + ' ' + insChargeArr.lia_insurance_type}})
                                                            </div>
                                                            <div class="col-md-4" :key="'liability_ins' + inschargekey">
                                                                : {{ numberFormat(insChargeArr.liability_insurance_total)}}
                                                            </div>
                                                        </div>
                                                        <div class="row table-view-detail" v-if="insChargeArr.liability_admin_charges != undefined" :key="'lia_admin'+inschargekey">
                                                            <div class="col-md-8" :key="'liability_admin_detail' + inschargekey">
                                                                {{ucStringKey(insChargeArr.lia_admincharges_name)}} <br>($ {{numberFormat(insChargeArr.liability_admin_charges) + " X " + insChargeArr.days + ' ' + insChargeArr.lia_admin_type}})
                                                            </div>
                                                            <div class="col-md-4" :key="'liability_admin' + inschargekey">
                                                                : {{ numberFormat(insChargeArr.liability_admin_total)}}
                                                            </div>
                                                        </div>
                                                    </template>
                                                </p>
                                                <p v-else>
                                                    -
                                                </p>
                                            </template>
                                            <template v-else-if="label=='reading_in'">
                                                <p v-if="section.new_value.length">
                                                    <template v-for="(readingArr , readinkey) in section.new_value">
                                                        <div class="row table-view-detail" v-if="readingArr.section_id != undefined" :key="'read'+readinkey">
                                                            <div class="col-md-8" :key="'readDetail' + readinkey">
                                                                {{ucStringKey(readingArr.section)}} &nbsp;: {{readingArr.reading_in}}
                                                            </div>
                                                            <div class="col-md-6" :key="'readDetail' + readinkey">
                                                                {{ readingArr.reading_in_date}}
                                                            </div>
                                                        </div>
                                                    </template>
                                                </p>
                                                <p v-else>-</p>
                                            </template>
                                            <template v-else-if="label=='reading_out'">
                                                <p v-if="section.new_value.length">
                                                    <template v-for="(readingOutArr , readoutkey) in section.new_value">
                                                        <div class="row table-view-detail" v-if="readingOutArr.section_id != undefined" :key="'readout'+readoutkey">
                                                            <div class="col-md-8" :key="'readOutDetail' + readoutkey">
                                                                {{ucStringKey(readingOutArr.section)}} &nbsp;: {{readingOutArr.reading_out}}
                                                            </div>

                                                            <div class="col-md-6" :key="'readOutDetail' + readoutkey">
                                                                 {{ readingOutArr.reading_out_date}}
                                                            </div>
                                                        </div>
                                                    </template>
                                                </p>
                                                <p v-else>-</p>
                                            </template>
                                            <template v-else>
                                                {{ ucStringValue(section.new_value) }}
                                            </template>
                                        </td>
                                        <td style="word-wrap: break-word; white-space: normal">
                                            <template v-if="label=='doc_path' || label=='insurance_doc' || label=='resale_doc_path' || label=='img_path' || label=='file_path' || label == 'insurance_certificate_path'">
                                                <p v-fp-html="section.old_value"></p>
                                            </template>
                                            <template v-else-if="label=='signature' || label=='signature1'">
                                                <p v-if="section.old_value!='-'"><img :src="section.old_value" height="200" width="200" alt=""></p>
                                                <p v-else>{{section.old_value}}</p>
                                            </template>
                                            <template v-else-if="label=='other_rates' || label=='final_rates'">
                                                <p v-if="section.old_value.length">
                                                    <template v-for="(othrateArr , othratekey) in section.old_value">
                                                        <div class="row table-view-detail" :key="othratekey">
                                                            <div class="col-md-8" v-if="othrateArr.name === 'government_compliance'">
                                                                Govt. Compliance <br>($ {{numberFormat(othrateArr.rate) + " X " + othrateArr.unit + ' ' + othrateArr.type}})
                                                            </div>
                                                            <div class="col-md-8" v-else>
                                                                {{ucStringKey(othrateArr.name)}} <br>($ {{numberFormat(othrateArr.rate) + " X " + othrateArr.unit + ' ' + othrateArr.type}})
                                                            </div>
                                                            <div class="col-md-4">
                                                                : {{ numberFormat(othrateArr.total)}}
                                                            </div>
                                                        </div>
                                                    </template>
                                                </p>
                                                <p v-else>-</p>
                                            </template>
                                            <template v-else-if="label=='insurance_rates'">
                                                <p v-if="section.old_value.length">
                                                    <template v-for="(insuranceArr , insurancekey) in section.old_value">
                                                        <div class="row table-view-detail" :key="insurancekey">
                                                            Insurance Name: {{ucStringKey(insuranceArr.Insurance_name)}}<br>
                                                            Days :{{insuranceArr.Days}}<br>
                                                            Type :{{insuranceArr.type}}<br>
                                                            Insurance Charge :{{numberFormat(insuranceArr.Insurance_charge)}}<br>
                                                            Total :{{numberFormat(insuranceArr.Total)}}<br>
                                                        </div>
                                                    </template>
                                                </p>
                                                <p v-else>-</p>
                                            </template>
                                            <template v-else-if="label=='extra_features'">
                                                <p v-if="section.old_value.length">
                                                    <template v-for="(featureArr , featurekey) in section.old_value">
                                                        <div class="row table-view-detail" :key="featurekey">
                                                            {{ucStringKey(featureArr.text)}} : {{ucStringKey(featureArr.value)}}<br>
                                                        </div>
                                                    </template>
                                                </p>
                                                <p v-else>-</p>
                                            </template>
                                            <template v-else-if="label=='insurance_charges'">
                                                <p v-if="section.old_value.length">
                                                    <template v-for="(insChargeArr , inschargekey) in section.old_value">
                                                        <div class="row table-view-detail" v-if="insChargeArr.physical_ins_charges != undefined" :key="'phy'+inschargekey">
                                                            <div class="col-md-8" :key="'physical_ins_detail' + inschargekey">
                                                                {{ucStringKey(insChargeArr.phy_charges_name)}} <br>($ {{numberFormat(insChargeArr.physical_ins_charges) + " X " + insChargeArr.days + ' ' + insChargeArr.phy_charges_type}})
                                                            </div>
                                                            <div class="col-md-4" :key="'physical_ins' + inschargekey">
                                                                : {{ numberFormat(insChargeArr.physical_ins_total)}}
                                                            </div>
                                                        </div>
                                                        <div class="row table-view-detail" v-if="insChargeArr.physical_admin_charges != undefined" :key="'phy_admin'+inschargekey">
                                                            <div class="col-md-8" :key="'physical_admin_detail' + inschargekey">
                                                                {{ucStringKey(insChargeArr.phy_admincharges_name)}} <br>($ {{numberFormat(insChargeArr.physical_admin_charges) + " X " + insChargeArr.days + ' ' + insChargeArr.phy_admin_type}})
                                                            </div>
                                                            <div class="col-md-4" :key="'physical_admin' + inschargekey">
                                                                : {{ numberFormat(insChargeArr.physical_admin_total)}}
                                                            </div>
                                                        </div>
                                                        <div class="row table-view-detail" v-if="insChargeArr.liability_insurance_charges != undefined" :key="'lia'+inschargekey">
                                                            <div class="col-md-8" :key="'liability_ins_detail' + inschargekey">
                                                                {{ucStringKey(insChargeArr.lia_insurance_name)}} <br>($ {{numberFormat(insChargeArr.liability_insurance_charges) + " X " + insChargeArr.days + ' ' + insChargeArr.lia_insurance_type}})
                                                            </div>
                                                            <div class="col-md-4" :key="'liability_ins' + inschargekey">
                                                                : {{ numberFormat(insChargeArr.liability_insurance_total)}}
                                                            </div>
                                                        </div>
                                                        <div class="row table-view-detail" v-if="insChargeArr.liability_admin_charges != undefined" :key="'lia_admin'+inschargekey">
                                                            <div class="col-md-8" :key="'liability_admin_detail' + inschargekey">
                                                                {{ucStringKey(insChargeArr.lia_admincharges_name)}} <br>($ {{numberFormat(insChargeArr.liability_admin_charges) + " X " + insChargeArr.days + ' ' + insChargeArr.lia_admin_type}})
                                                            </div>
                                                            <div class="col-md-4" :key="'liability_admin' + inschargekey">
                                                                : {{ numberFormat(insChargeArr.liability_admin_total)}}
                                                            </div>
                                                        </div>
                                                    </template>
                                                </p>
                                                <p v-else>-</p>
                                            </template>
                                            <template v-else-if="label=='reading_in'">
                                                <p v-if="section.old_value.length">
                                                    <template v-for="(oldReadin , readinoldkey) in section.old_value">
                                                        <div class="row table-view-detail" v-if="oldReadin.section_id != undefined" :key="'readOld'+readinoldkey">
                                                            <div class="col-md-8" :key="'read_detail' + readinoldkey">
                                                                {{ucStringKey(oldReadin.section)}} &nbsp;:{{oldReadin.reading_in}}
                                                            </div>

                                                            <div class="col-md-6" :key="'read_detail' + readinoldkey">
                                                                : {{ oldReadin.reading_in_date}}
                                                            </div>
                                                        </div>
                                                    </template>
                                                </p>
                                                <p v-else>-</p>
                                            </template>
                                            <template v-else-if="label=='reading_out'">
                                                <p v-if="section.old_value.length">
                                                    <template v-for="(oldReadinOut , readoutoldkey) in section.old_value">
                                                        <div class="row table-view-detail" v-if="oldReadinOut.section_id != undefined" :key="'readOutOld'+readoutoldkey">
                                                            <div class="col-md-8" :key="'read_out_detail' + readoutoldkey">
                                                                {{ucStringKey(oldReadinOut.section)}} &nbsp;:{{oldReadinOut.reading_out}}
                                                            </div>

                                                            <div class="col-md-6" :key="'read_out_detail' + readoutoldkey">
                                                                : {{ oldReadinOut.reading_out_date}}
                                                            </div>
                                                        </div>
                                                    </template>
                                                </p>
                                                <p v-else>-</p>
                                            </template>
                                            <template v-else>
                                                {{ ucStringValue(section.old_value) }}
                                            </template>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" data-dismiss="modal" > <i class="fp-close"> </i> Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import EventBus from "././event-bus";

import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

export default {
    name: "ActivityLogList",
    components: {



    },
    mixins:[commonMixins,dataTableMixins],
    props: {
        activityLogVal: {
            type: String,
            required: false,
            default:undefined
        }
    },
    data: () => ({
        firstLoad: 0,
        permissions: [],
        userColumns:[],
        cantAccessPage: "",
        columns: [
            {
                label: 'Actions',
                field: 'action',
                sortable: false,
                hidden: false,
                filterable: false,
            },
            {
                label: 'Module',
                field: 'module',
                filterable: true,
                fpFieldType:"option",
                hidden: false,
            },
            {
                label: 'Name',
                field: 'name',
                filterable: true,
                fpFieldType:"text",
                hidden: false,
            },
            {
                label: 'Description',
                field: 'description',
                filterable: true,
                fpFieldType:"text",
                hidden: false,
            },
            {
                label: 'Performed By',
                field: 'performed_by',
                filterable: true,
                fpFieldType:"text",
                hidden: false,
            },
            {
                label: 'Performed At',
                field: 'performed_at',
                fpFieldType:"date",
                filterable: true,
                hidden: false,
            },
        ],
        rows: [],
        totalRecords: 0,
        loading:false,
        pPage:5,
        increasePage:5,
        activityLogViewHeader: 'Activity Log Detail',
        fieldArr: [],
        id:0,
        module:'All',
        page:1,
        canViewLog:false,
        pageKey:"_activity_log_list_",
        pageTitle : "Activity Log List",
    }),
    metaInfo () {
        if (this.activityLogVal == undefined) {
            return {
                title: (this.$route.query.flag == 'priceLog')? "Price Book History | FleetPro Application" : "Activity Log List | FleetPro Application"
            }
        }
    },
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'list_activity_log') {
                        self.cantAccessPage = true;
                    }
                    if (permissions[i].name == 'view_activity_log') {
                        self.canViewLog = true;
                    }

                }
            }

        }
    },
    created: function() {

    },
    beforeDestroy(){
        this.$root.$off('activity_log_opted');
    },
    mounted: function() {
        var self = this;
        //self.loadList();
        // self.getPermissions();

            this.$root.$on("activity_log_opted",(moduleName,moduleId)=>{
                // self.flag = "selectedWorkorderActivityLog"; //if asset view
            if(moduleName=='All')
            {
                self.module='All';
            }else{
                self.module=moduleName;
                self.id = moduleId;
                // self.activityLogVal = "loadList";
            }
            /*var path = window.location.pathname;
            var asset = path.split("/");
            // var urlFlag = asset[1];
            var urlFlag = moduleName;
            self.id = asset[3];
                alert('before url');
            self.activityLogVal = "loadList";
            alert("url is "+urlFlag)
            //if customer view
            if(urlFlag == 'customer'){
                self.customerId = asset[3];
                self.flag = "selectedCustomerActivityLog";
            }else if(urlFlag == 'asset'){
                self.flag = "selectedAssetActivityLog"; //if asset view
            }else if(urlFlag == 'work order'){
                self.flag = "selectedWorkorderActivityLog"; //if asset view
                self.module=moduleName;
                self.id = moduleId;
            }*/

            // self.flag = self.activityLogVal;

            //for now hide unit and name datatable column
            for (let index = 0; index < this.columns.length; index++) {

                if(this.columns[index].field == 'module'){
                        this.$set(this.columns[index], 'hidden', true);
                }

            }

            self.getPermissions();
            self.loadList();
        }

        );

        //when component list directly call from url instead of in view page than call permission request
        if ( self.activityLogVal == undefined ) {
                if(self.$route.query.flag == 'priceLog'){

                self.pageTitle = "Price Book History";
                for (let index = 0; index < this.columns.length; index++) {

                    if(this.columns[index].field == 'module' || this.columns[index].field == 'name'){
                            this.$set(this.columns[index], 'hidden', true);
                    }

                }

                }

            self.getPermissions();
        }

    },
    methods: {

        cancelAll: function (cancelAll) {
            this.$refs.listActivityLogTable.unselectAllInternal();
        },
        selectionChanged(param) {
            var self = this;
            if(param.selectedRows.length == 100) {
                EventBus.$emit('clear-selection', false);
            } else {
                EventBus.$emit('clear-all-flags', false);
            }
        },
        loadMoreData(){
            var self = this;

            // self.page = self.page+1;
            self.pPage += self.increasePage;

            self.loadList();
        },

        loadList() {
            var self = this;
            // var id = 0;
            // if(self.activityLogVal == 'selectedCustomerActivityLog' || self.activityLogVal == "selectedAssetActivityLog"){

            //     var path = window.location.pathname;
            //     var asset = path.split("/");
            //     id = asset[3];
            //     // if(self.activityLogVal == "selectedAssetActivityLog"){
            //     //     self.assetId = asset[3];
            //     // }else{
            //         self.customerId = asset[3];
            //     // }

            //     self.flag = self.activityLogVal;

            //     //for now hide unit and name datatable column
            //     for (let index = 0; index < this.columns.length; index++) {

            //         if(this.columns[index].field == 'module'){
            //             this.$set(this.columns[index], 'hidden', true);
            //         }

            //     }

            // }

            if( self.activityLogVal == 'dontLoadList' ){
                return;
            }
            if(self.$route.query.flag == 'priceLog'){
                //setting the module name if PriceBookHistory is clicked under Maintenance Tab
                self.module = "priceBook";

            }

            if ( self.activityLogVal != undefined && self.activityLogVal == 'woloadList') {
                var fields = {
                    page: self.page,
                    perPage: self.pPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    // flag: self.flag,
                    module_name:self.module,
                    customer_id: self.customerId,
                    id:self.id
                };

            }else{

                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    // flag: self.flag,
                    module_name:self.module,
                    customer_id: self.customerId,
                    id:self.id
                };
            }
            self.loading = true;
            self.firstLoad = 1;

            $.ajax({
                url: process.env.ROOT_API + "/activitylog/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    console.log('activity data')
                    console.log(data);
                    self.loading = false;
                    if (data.status == "success") {
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'activityloglist');

                }
            });
        },

        //make sentence first letter capital
        ucStringKey(data) {
            var self = this;
            var string = (data != null || data != undefined)?data.toString().trim():'';

            if(string != ''){

                if(self.module=='customer estimate')
                {
                    var value = string.replace("work_order", "").replace("_id", "");
                }else{
                    var value = string.replace("_id", "");
                }
                var value1 = value.replace(/_/g, " ");

                var upp = value1.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;

            }else{
                return '-';
            }

        },

        //make sentence first letter capital
        ucStringValue(data) {
            var self = this;
            var string = (data != null || data != undefined)?data.toString().trim():'';

            if(string != ''){

                var value = string.replace(/_/g, " ");

                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;

            }else{
                return '-';
            }

        },

        //remove unnecessary key's from arr
        removeKey(arr){
            if(arr.hasOwnProperty('id')){
                delete arr['id'];
            }
            if(arr.hasOwnProperty('updated_at')){
                delete arr['updated_at'];
            }
            if(arr.hasOwnProperty('updated_by')){
                delete arr['updated_by'];
            }
            if(arr.hasOwnProperty('created_at')){
                delete arr['created_at'];
            }
            if(arr.hasOwnProperty('created_by')){
                delete arr['created_by'];
            }
            if(arr.hasOwnProperty('deleted_at')){
                delete arr['deleted_at'];
            }
            if(arr.hasOwnProperty('deleted_by')){
                delete arr['deleted_by'];
            }
        },

        getActivityLogInfo(logId){
            var self = this;
            self.loading = true;
            self.fieldArr = [];

            $.ajax({
                url: process.env.ROOT_API + "/activitylog/info",
                type: "GET",
                data: {id:logId},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {

                    console.log(data);
                    self.loading = false;
                    self.readingError = "";
                    $("#activityLogViewModal").modal('show');
                    if (data.status == "success") {
                        self.activityLogViewHeader = data.content.moduleName + ' Activity Log Details';
                        if(data.content.field.other_rates)
                        {
                            if(data.content.field.other_rates.new_value=='-' || data.content.field.other_rates.new_value==null) {
                                data.content.field.other_rates.new_value = [];
                            }else{
                                data.content.field.other_rates.new_value = JSON.parse(data.content.field.other_rates.new_value);
                            }
                                if(data.content.field.other_rates.old_value=='-' || data.content.field.other_rates.old_value==null)
                                {
                                    data.content.field.other_rates.old_value=[];
                                }else{
                                    data.content.field.other_rates.old_value=JSON.parse(data.content.field.other_rates.old_value);

                                }

                        }
                        if(data.content.field.final_rates)
                        {

                            if(data.content.field.final_rates.new_value=='-' || data.content.field.final_rates.new_value==null) {
                                data.content.field.final_rates.new_value = [];
                            }else{
                                data.content.field.final_rates.new_value = JSON.parse(data.content.field.final_rates.new_value);
                            }
                            if(data.content.field.final_rates.old_value=='-' || data.content.field.final_rates.old_value==null)
                            {
                                data.content.field.final_rates.old_value=[];
                            }else{
                                data.content.field.final_rates.old_value=JSON.parse(data.content.field.final_rates.old_value);

                            }
                        }
                        if(data.content.field.insurance_rates)
                        {

                            if(data.content.field.insurance_rates.new_value=='-' || data.content.field.insurance_rates.new_value==null) {
                                data.content.field.insurance_rates.new_value = [];
                            }else{
                                data.content.field.insurance_rates.new_value = JSON.parse(data.content.field.insurance_rates.new_value);
                            }
                            if(data.content.field.insurance_rates.old_value=='-' || data.content.field.insurance_rates.old_value==null)
                            {
                                data.content.field.insurance_rates.old_value=[];
                            }else{
                                data.content.field.insurance_rates.old_value=JSON.parse(data.content.field.insurance_rates.old_value);

                            }
                        }
                        if(data.content.field.extra_features)
                        {

                            if(data.content.field.extra_features.new_value=='-' || data.content.field.extra_features.new_value==null) {
                                data.content.field.extra_features.new_value = [];
                            }else{
                                data.content.field.extra_features.new_value = JSON.parse(JSON.stringify(data.content.field.extra_features.new_value));
                                $.each(data.content.field.extra_features.new_value, function(i, item) {
                                    data.content.field.extra_features.new_value[i]=JSON.parse(item);
                                })
                            }
                            if(data.content.field.extra_features.old_value=='-' || data.content.field.extra_features.old_value==null)
                            {
                                data.content.field.extra_features.old_value=[];
                            }else{
                                $.each(data.content.field.extra_features.old_value, function(i, item) {
                                    data.content.field.extra_features.old_value[i]=JSON.parse(item);
                                })
                            }
                        }
                        if(data.content.field.insurance_charges)
                        {

                            if(data.content.field.insurance_charges.new_value=='-' || data.content.field.insurance_charges.new_value==null) {
                                data.content.field.insurance_charges.new_value = [];
                            }else{
                                data.content.field.insurance_charges.new_value = JSON.parse(data.content.field.insurance_charges.new_value);
                            }
                            if(data.content.field.insurance_charges.old_value=='-' || data.content.field.insurance_charges.old_value==null)
                            {
                                data.content.field.insurance_charges.old_value=[];
                            }else{
                                data.content.field.insurance_charges.old_value=JSON.parse(data.content.field.insurance_charges.old_value);

                            }
                        }

                        if(data.content.field.reading_in)
                        {

                            if(data.content.field.reading_in.new_value=='-' || data.content.field.reading_in.new_value==null) {
                                data.content.field.reading_in.new_value = [];
                            }else{
                                data.content.field.reading_in.new_value = JSON.parse(data.content.field.reading_in.new_value);
                            }
                            if(data.content.field.reading_in.old_value=='-' || data.content.field.reading_in.old_value==null)
                            {
                                data.content.field.reading_in.old_value=[];
                            }else{
                                data.content.field.reading_in.old_value=JSON.parse(data.content.field.reading_in.old_value);

                            }
                        }
                        if(data.content.field.reading_out)
                        {

                            if(data.content.field.reading_out.new_value=='-' || data.content.field.reading_out.new_value==null) {
                                data.content.field.reading_out.new_value = [];
                            }else{
                                data.content.field.reading_out.new_value = JSON.parse(data.content.field.reading_out.new_value);
                            }
                            if(data.content.field.reading_out.old_value=='-' || data.content.field.reading_out.old_value==null)
                            {
                                data.content.field.reading_out.old_value=[];
                            }else{
                                data.content.field.reading_out.old_value=JSON.parse(data.content.field.reading_out.old_value);

                            }
                        }

                        self.fieldArr = data.content.field;

                        self.removeKey(self.fieldArr);
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'activityloginfo');

                }
            });

        },
    },
};

</script>



// WEBPACK FOOTER //
// src/components/ActivityLogList.vue